<div class="invoices-v2-container">
  <div class="main-card">
    <!-- Page header: single title + create action -->
    <div class="card-header-custom">
      <h1 class="header-title">
        <i class="fa fa-file-text-o" aria-hidden="true"></i>
        {{ 'invoices_v2.common.invoices_v2_title' | translate }}
      </h1>

      <div class="header-actions" *ngIf="canIssueDocumentAllowed">
        <button type="button" class="btn-add" (click)="createInvoice()">
          <i class="fa fa-plus-circle" aria-hidden="true"></i>
          {{ 'invoices_v2.list.create_invoice' | translate }}
        </button>
      </div>

      <!-- Quota exceeded notice -->
      <div *ngIf="!canIssueDocumentAllowed" class="quota-limit-notice" role="status">
        <span class="quota-limit-icon" aria-hidden="true"><i class="fa fa-lock"></i></span>
        <div class="quota-limit-copy">
          <span class="quota-limit-text">
            {{ 'invoices_v2.list.document_limit_reached' | translate }}
          </span>
          <span class="quota-limit-hint">
            {{ 'invoices_v2.list.document_limit_hint' | translate }}
          </span>
        </div>
        <a [routerLink]="['/dashboard/invoice-subscriptions']" class="quota-upgrade-btn">
          {{ 'invoices_v2.list.upgrade_plan' | translate }}
          <i class="fa fa-external-link quota-upgrade-btn__icon" aria-hidden="true"></i>
        </a>
      </div>
    </div>

    <!-- Current BOI exchange rates -->
    <div class="exchange-rates-strip" *ngIf="currentExchangeRates.length">
      <span class="exchange-rates-strip__label">
        <i class="fa fa-exchange" aria-hidden="true"></i>
        {{ 'invoices_v2.currency.current_rates' | translate }}
        <small *ngIf="currentExchangeRatesAsOf" class="exchange-rates-strip__date">
          ({{ currentExchangeRatesAsOf }})
        </small>
      </span>
      <div class="exchange-rates-strip__chips">
        <span class="exchange-rates-strip__chip" *ngFor="let rate of currentExchangeRates">
          <strong>{{ rate.currency_code }}</strong>
          {{ rate.exchange_rate | number: '1.2-4' }} ₪
        </span>
      </div>
    </div>

    <!-- Filters Section -->
    <div class="filters-section" [class.filters-section--panels-hidden]="!filtersSectionExpanded">
      <div class="filters-toolbar">
        <div class="filters-toolbar__lead">
          <div class="filters-toolbar__text">
            <h2 class="filters-toolbar__title">
              {{ 'invoices_v2.list.search_filters' | translate }}
              <span class="filters-toolbar__active-badge" *ngIf="countActiveFilters()">
                {{ countActiveFilters() }}
              </span>
            </h2>
            <div class="filters-toolbar__subtitle-row" *ngIf="filtersSectionExpanded">
              <p class="filters-toolbar__subtitle">{{ 'invoices_v2.list.filter_toolbar_hint' | translate }}</p>
            </div>
          </div>
        </div>
        <div class="filters-toolbar__trail">
          <button
            type="button"
            class="filters-toolbar__toggle-btn"
            (click)="toggleFiltersSection()"
            [attr.aria-expanded]="filtersSectionExpanded"
          >
            <i class="fa fa-sliders" aria-hidden="true"></i>
            <span>{{
              (filtersSectionExpanded
                ? 'invoices_v2.list.filter_toggle_hide'
                : 'invoices_v2.list.filter_toggle_show'
              ) | translate
            }}</span>
            <span class="filters-toolbar__toggle-badge" *ngIf="!filtersSectionExpanded && countActiveFilters()">
              {{ countActiveFilters() }}
            </span>
          </button>
          <span class="filters-toolbar__trail-divider" aria-hidden="true"></span>
          <ng-container *ngIf="!filtersSectionExpanded">
            <button type="button" class="btn-filter-secondary" (click)="resetFilters()">
              <i class="fa fa-undo" aria-hidden="true"></i>
              {{ 'invoices_v2.list.reset' | translate }}
            </button>
            <span class="filters-toolbar__trail-divider" aria-hidden="true"></span>
          </ng-container>
          <button
            type="button"
            class="btn-export btn-export--print"
            (click)="printSelectedDocuments()"
            [disabled]="!hasListSelection || isLoading || isExporting"
            [attr.aria-busy]="isExporting"
          >
            <i class="fa fa-print" aria-hidden="true"></i>
            {{ 'invoices_v2.list.print_selected' | translate }}
          </button>
          <button
            type="button"
            class="btn-export btn-export--pdf"
            (click)="onToolbarPdfClick()"
            [disabled]="isLoading || isExporting"
            [attr.aria-busy]="isExporting"
          >
            <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
            {{ 'invoices_v2.list.export_pdf' | translate }}
          </button>
          <button
            type="button"
            class="btn-export btn-export--excel"
            (click)="onToolbarExcelClick()"
            [disabled]="isLoading || isExporting"
          >
            <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            {{ 'invoices_v2.list.export_excel' | translate }}
          </button>
        </div>
      </div>

      <div class="filters-card-shell" *ngIf="filtersSectionExpanded">
        <nav class="filter-tabs" role="tablist" [attr.aria-label]="'invoices_v2.list.search_filters' | translate">
          <button
            *ngFor="let tab of filterTabs"
            type="button"
            role="tab"
            class="filter-tabs__tab"
            [class.filter-tabs__tab--active]="activeFilterTab === tab.id"
            [attr.aria-selected]="activeFilterTab === tab.id"
            (click)="setActiveFilterTab(tab.id)"
          >
            <i class="fa" [ngClass]="tab.icon" aria-hidden="true"></i>
            <span class="filter-tabs__label">{{ tab.labelKey | translate }}</span>
            <span class="filter-tabs__badge" *ngIf="countFilterSection(tab.id)">{{ countFilterSection(tab.id) }}</span>
          </button>
        </nav>

        <div class="filters-card">
          <div class="filters-card__scroll">
        <!-- 1. Search -->
        <div class="filter-panel" *ngIf="activeFilterTab === 'search'" role="tabpanel">
          <p class="filter-panel__intro">{{ 'invoices_v2.list.filter_subsection_search_caption' | translate }}</p>
              <div class="filters-grid filters-grid--search">
                <div class="filter-group filter-group--full">
                  <label class="filter-label">{{ 'invoices_v2.common.search' | translate }}</label>
                  <div class="filter-input-with-icon">
                    <i class="fa fa-search filter-input-with-icon__glyph" aria-hidden="true"></i>
                    <input
                      class="form-control-custom form-control-custom--padded-icon"
                      type="text"
                      [(ngModel)]="searchKeyword"
                      (ngModelChange)="onTextFilterChange()"
                      [placeholder]="'invoices_v2.list.search_placeholder' | translate"
                    />
                  </div>
                </div>
              </div>
        </div>

        <!-- 2. Scope -->
        <div class="filter-panel" *ngIf="activeFilterTab === 'scope'" role="tabpanel">
          <p class="filter-panel__intro">{{ 'invoices_v2.list.filter_subsection_scope_caption' | translate }}</p>
              <div class="filters-grid filters-grid--scope filters-grid--scope-tiered">
                <div class="filter-group filter-group--span-2">
                  <label class="filter-label">{{ 'invoices_v2.common.company' | translate }}</label>
                  <ng-select
                    class="ng-select-custom"
                    [(ngModel)]="selectedCompany"
                    (change)="onCompanyFilterChange()"
                    [placeholder]="'invoices_v2.list.all_companies' | translate"
                  >
                    <ng-option [value]="allCompaniesOption">
                      {{ 'invoices_v2.list.all_companies' | translate }}
                    </ng-option>
                    <ng-option *ngFor="let company of companyData" [value]="company">
                      {{
                        (company | companyName:curentLang)}}
                      <span *ngIf="company.company_status === 'ARCHIVED'" style="font-size:11px;color:#888;margin-inline-start:6px;">
                        ({{ curentLang === 'ar' ? 'مؤرشفة' : (curentLang === 'en' ? 'Archived' : 'בארכיון') }})
                      </span>
                    </ng-option>
                  </ng-select>
                </div>
                <div class="filter-group filter-group--span-2" *ngIf="selectedCompany?.company_id">
                  <label class="filter-label">{{ 'invoices_v2.list.filter_customer' | translate }}</label>
                  <ng-select
                    class="ng-select-custom"
                    [(ngModel)]="selectedCustomerId"
                    (change)="applyFilters()"
                    [clearable]="true"
                    [placeholder]="'invoices_v2.list.all_customers' | translate"
                  >
                    <ng-option [value]="null">{{ 'invoices_v2.list.all_customers' | translate }}</ng-option>
                    <ng-option *ngFor="let c of filterCustomers" [value]="c.customer_id">
                      {{ filterCustomerLabel(c) }}
                    </ng-option>
                  </ng-select>
                </div>
                <div class="filter-group filter-group--span-2 filter-group--placeholder" *ngIf="!selectedCompany?.company_id">
                  <label class="filter-label">{{ 'invoices_v2.list.filter_customer' | translate }}</label>
                  <div class="filter-muted-hint">{{ 'invoices_v2.list.filter_customer_company_first' | translate }}</div>
                </div>
                <div class="filter-group">
                  <label class="filter-label">{{ 'invoices_v2.common.invoice_type' | translate }}</label>
                  <ng-select
                    class="ng-select-custom"
                    [(ngModel)]="selectedInvoiceTypes"
                    (change)="applyFilters()"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [clearable]="true"
                    [placeholder]="'invoices_v2.list.all_types' | translate"
                  >
                    <ng-option *ngFor="let type of invoiceTypes" [value]="+type.id">
                      {{
                        curentLang === 'en'
                          ? type.name_en
                          : curentLang === 'ar'
                            ? type.name_ar
                            : type.name_he
                      }}
                    </ng-option>
                  </ng-select>
                </div>
                <div class="filter-group">
                  <label class="filter-label">{{ 'invoices_v2.currency.document_currency' | translate }}</label>
                  <ng-select
                    class="ng-select-custom"
                    [(ngModel)]="selectedDocumentCurrencies"
                    (change)="applyFilters()"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [clearable]="true"
                    [placeholder]="'invoices_v2.list.all_currencies' | translate"
                  >
                    <ng-option *ngFor="let c of filterCurrencyOptions" [value]="c.currency_code">
                      {{ filterCurrencyLabel(c.currency_code) }}
                    </ng-option>
                  </ng-select>
                </div>
                <div class="filter-group">
                  <label class="filter-label">{{ 'invoices_v2.common.status' | translate }}</label>
                  <ng-select
                    class="ng-select-custom"
                    [(ngModel)]="selectedStatus"
                    (change)="applyFilters()"
                    [clearable]="true"
                    [placeholder]="'invoices_v2.list.all_statuses' | translate"
                  >
                    <ng-option [value]="null">
                      {{ 'invoices_v2.list.all_statuses' | translate }}
                    </ng-option>
                    <ng-option [value]="InvoiceStatus.CONFIRMED">
                      {{ 'invoices_v2.list.confirmed_status' | translate }}
                    </ng-option>
                    <ng-option [value]="InvoiceStatus.SAVED">
                      {{ 'invoices_v2.list.saved_status' | translate }}
                    </ng-option>
                    <ng-option [value]="InvoiceStatus.DELETED">
                      {{ 'invoices_v2.list.deleted_status' | translate }}
                    </ng-option>
                  </ng-select>
                </div>
              </div>
        </div>

        <!-- 3. Period & amounts -->
        <div class="filter-panel" *ngIf="activeFilterTab === 'period'" role="tabpanel">
          <p class="filter-panel__intro">{{ 'invoices_v2.list.filter_subsection_period_caption' | translate }}</p>
              <div class="date-filter-block">
                <div class="date-filter-block__presets">
                  <span class="date-filter-block__presets-label">{{ 'invoices_v2.list.date_presets_label' | translate }}</span>
                  <div class="date-filter-block__chip-groups" role="group" [attr.aria-label]="'invoices_v2.list.date_presets_label' | translate">
                    <div class="date-filter-block__chip-group" *ngFor="let group of datePresetGroups">
                      <span class="date-filter-block__chip-group-label">
                        {{ ('invoices_v2.list.date_preset_group_' + group.groupKey) | translate }}
                      </span>
                      <div class="date-filter-block__chips">
                        <button
                          *ngFor="let preset of group.presets"
                          type="button"
                          class="date-preset-chip"
                          [class.date-preset-chip--active]="activeDatePreset === preset"
                          (click)="applyDatePreset(preset)"
                        >
                          {{ datePresetLabelKey(preset) | translate }}
                        </button>
                      </div>
                    </div>
                    <div class="date-filter-block__chip-group" *ngIf="hasSubscriptionPeriod()">
                      <span class="date-filter-block__chip-group-label">
                        {{ 'invoices_v2.list.date_preset_group_subscription' | translate }}
                      </span>
                      <div class="date-filter-block__chips">
                        <button
                          type="button"
                          class="date-preset-chip date-preset-chip--subscription"
                          [class.date-preset-chip--active]="activeDatePreset === 'subscription_period'"
                          (click)="applySubscriptionPeriodFilter()"
                        >
                          {{ 'invoices_v2.list.date_preset_subscription_period' | translate }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="date-filter-block__range">
                  <div class="date-range-grid">
                    <div class="filter-group">
                      <label class="filter-label" for="inv-v2-from-date">{{ 'invoices_v2.list.from_date' | translate }}</label>
                      <p-calendar
                        inputId="inv-v2-from-date"
                        class="p-calendar-custom"
                        [(ngModel)]="fromDate"
                        (ngModelChange)="onManualDateChange()"
                        [showIcon]="true"
                        appendTo="body"
                        dateFormat="dd/mm/yy"
                        [selectOtherMonths]="true"
                        [placeholder]="'invoices_v2.list.date_placeholder' | translate"
                        [maxDate]="toDate || maxFilterDate"
                        [showButtonBar]="true"
                        [todayButtonStyleClass]="'p-button-text'"
                        [clearButtonStyleClass]="'p-button-text'"
                      ></p-calendar>
                    </div>
                    <span class="date-range-grid__sep" aria-hidden="true">
                      <i class="fa fa-long-arrow-right"></i>
                    </span>
                    <div class="filter-group">
                      <label class="filter-label" for="inv-v2-to-date">{{ 'invoices_v2.list.to_date' | translate }}</label>
                      <p-calendar
                        inputId="inv-v2-to-date"
                        class="p-calendar-custom"
                        [(ngModel)]="toDate"
                        (ngModelChange)="onManualDateChange()"
                        [showIcon]="true"
                        appendTo="body"
                        dateFormat="dd/mm/yy"
                        [selectOtherMonths]="true"
                        [placeholder]="'invoices_v2.list.date_placeholder' | translate"
                        [minDate]="fromDate"
                        [maxDate]="maxFilterDate"
                        [showButtonBar]="true"
                        [todayButtonStyleClass]="'p-button-text'"
                        [clearButtonStyleClass]="'p-button-text'"
                      ></p-calendar>
                    </div>
                  </div>
                  <div class="date-filter-block__actions">
                    <button type="button" class="btn-date-clear" (click)="clearDateRange()" [disabled]="!fromDate && !toDate">
                      <i class="fa fa-times-circle" aria-hidden="true"></i>
                      {{ 'invoices_v2.list.date_clear' | translate }}
                    </button>
                    <span class="date-filter-block__hint">{{ 'invoices_v2.list.filter_date_range_hint' | translate }}</span>
                  </div>
                </div>
              </div>
              <p class="filter-subsection__hint filter-subsection__hint--spaced">{{ 'invoices_v2.list.filter_amount_range_hint' | translate }}</p>
              <div class="filter-pair-row">
                <div class="filter-pair">
                  <div class="filter-group">
                    <label class="filter-label">{{ 'invoices_v2.list.min_amount' | translate }}</label>
                    <input type="number" class="form-control-custom" [(ngModel)]="minAmount" (ngModelChange)="onAmountFilterChange()" placeholder="0" />
                  </div>
                  <span class="filter-pair__join" aria-hidden="true"></span>
                  <div class="filter-group">
                    <label class="filter-label">{{ 'invoices_v2.list.max_amount' | translate }}</label>
                    <input type="number" class="form-control-custom" [(ngModel)]="maxAmount" (ngModelChange)="onAmountFilterChange()" placeholder="0" />
                  </div>
                </div>
              </div>

              <p class="filter-subsection__hint filter-subsection__hint--spaced">{{ 'invoices_v2.list.filter_due_date_range_hint' | translate }}</p>
              <div class="date-range-grid">
                <div class="filter-group">
                  <label class="filter-label" for="inv-v2-due-from">{{ 'invoices_v2.list.due_date_from' | translate }}</label>
                  <p-calendar
                    inputId="inv-v2-due-from"
                    class="p-calendar-custom"
                    [(ngModel)]="dueDateFrom"
                    (ngModelChange)="onDueDateChange()"
                    [showIcon]="true"
                    appendTo="body"
                    dateFormat="dd/mm/yy"
                    [selectOtherMonths]="true"
                    [placeholder]="'invoices_v2.list.date_placeholder' | translate"
                    [maxDate]="dueDateTo || maxFilterDate"
                    [showButtonBar]="true"
                    [todayButtonStyleClass]="'p-button-text'"
                    [clearButtonStyleClass]="'p-button-text'"
                  ></p-calendar>
                </div>
                <span class="date-range-grid__sep" aria-hidden="true">
                  <i class="fa fa-long-arrow-right"></i>
                </span>
                <div class="filter-group">
                  <label class="filter-label" for="inv-v2-due-to">{{ 'invoices_v2.list.due_date_to' | translate }}</label>
                  <p-calendar
                    inputId="inv-v2-due-to"
                    class="p-calendar-custom"
                    [(ngModel)]="dueDateTo"
                    (ngModelChange)="onDueDateChange()"
                    [showIcon]="true"
                    appendTo="body"
                    dateFormat="dd/mm/yy"
                    [selectOtherMonths]="true"
                    [placeholder]="'invoices_v2.list.date_placeholder' | translate"
                    [minDate]="dueDateFrom"
                    [maxDate]="maxFilterDate"
                    [showButtonBar]="true"
                    [todayButtonStyleClass]="'p-button-text'"
                    [clearButtonStyleClass]="'p-button-text'"
                  ></p-calendar>
                </div>
              </div>
              <div class="date-filter-block__actions">
                <button type="button" class="btn-date-clear" (click)="clearDueDateRange()" [disabled]="!dueDateFrom && !dueDateTo">
                  <i class="fa fa-times-circle" aria-hidden="true"></i>
                  {{ 'invoices_v2.list.due_date_clear' | translate }}
                </button>
              </div>
        </div>

        <!-- 4. Identifiers & sorting -->
        <div class="filter-panel" *ngIf="activeFilterTab === 'identifiers'" role="tabpanel">
          <p class="filter-panel__intro">{{ 'invoices_v2.list.filter_subsection_identifiers_caption' | translate }}</p>
              <div class="filters-grid filters-grid--identifiers-row">
                <div class="filter-group">
                  <label class="filter-label">{{ 'invoices_v2.list.filter_document_number' | translate }}</label>
                  <input
                    class="form-control-custom"
                    type="text"
                    [(ngModel)]="documentNumber"
                    (ngModelChange)="onTextFilterChange()"
                    [placeholder]="'invoices_v2.list.filter_document_number_ph' | translate"
                  />
                </div>
                <div class="filter-group">
                  <label class="filter-label">{{ 'invoices_v2.list.filter_confirmation_number' | translate }}</label>
                  <input
                    class="form-control-custom"
                    type="text"
                    [(ngModel)]="confirmationNumber"
                    (ngModelChange)="onTextFilterChange()"
                    [placeholder]="'invoices_v2.list.filter_confirmation_number_ph' | translate"
                  />
                </div>
                <div class="filter-group">
                  <label class="filter-label">{{ 'invoices_v2.list.filter_procedure_cycle' | translate }}</label>
                  <ng-select
                    class="ng-select-custom"
                    [(ngModel)]="isInProcedureCycle"
                    (change)="applyFilters()"
                    [clearable]="true"
                    [placeholder]="'invoices_v2.list.filter_any' | translate"
                  >
                    <ng-option [value]="true">{{ 'invoices_v2.list.filter_procedure_yes' | translate }}</ng-option>
                    <ng-option [value]="false">{{ 'invoices_v2.list.filter_procedure_no' | translate }}</ng-option>
                  </ng-select>
                </div>
                <div class="filter-group">
                  <label class="filter-label">{{ 'invoices_v2.list.filter_payment_status' | translate }}</label>
                  <ng-select
                    class="ng-select-custom"
                    [(ngModel)]="selectedPaymentStatuses"
                    (change)="applyFilters()"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [clearable]="true"
                    [placeholder]="'invoices_v2.list.all_payment_statuses' | translate"
                  >
                    <ng-option *ngFor="let ps of paymentStatusFilterOptions" [value]="ps">
                      {{ paymentStatusFilterLabel(ps) }}
                    </ng-option>
                  </ng-select>
                </div>
                <div class="filter-group">
                  <label class="filter-label">{{ 'invoices_v2.list.filter_has_due_date' | translate }}</label>
                  <ng-select
                    class="ng-select-custom"
                    [(ngModel)]="hasDueDate"
                    (change)="applyFilters()"
                    [clearable]="true"
                    [placeholder]="'invoices_v2.list.filter_any' | translate"
                  >
                    <ng-option [value]="true">{{ 'invoices_v2.list.filter_has_due_date_yes' | translate }}</ng-option>
                    <ng-option [value]="false">{{ 'invoices_v2.list.filter_has_due_date_no' | translate }}</ng-option>
                  </ng-select>
                </div>
              </div>
              <div class="filters-grid filters-grid--identifiers-sort">
                <div class="filter-group filter-group--sort-wide">
                  <label class="filter-label">{{ 'invoices_v2.list.filter_sort_combined' | translate }}</label>
                  <div class="filter-sort-inline">
                    <ng-select
                      class="ng-select-custom ng-select-custom--grow"
                      [(ngModel)]="filters.sortIndex"
                      (change)="applyFilters()"
                      [placeholder]="'invoices_v2.list.filter_sort_field' | translate"
                    >
                      <ng-option *ngFor="let idx of filterSortIndexOptions" [value]="idx">
                        {{ ('invoices_v2.list.sort_field_' + idx) | translate }}
                      </ng-option>
                    </ng-select>
                    <ng-select
                      class="ng-select-custom ng-select-custom--narrow"
                      [(ngModel)]="filters.sort"
                      (change)="applyFilters()"
                    >
                      <ng-option [value]="SortOrder.DESC">{{ 'invoices_v2.list.sort_desc' | translate }}</ng-option>
                      <ng-option [value]="SortOrder.ASC">{{ 'invoices_v2.list.sort_asc' | translate }}</ng-option>
                    </ng-select>
                  </div>
                </div>
              </div>
        </div>
          </div>
        </div>

        <div class="filters-card__footer">
          <div class="filters-card__footer-meta">
            <p class="filters-card__footer-hint">{{ 'invoices_v2.list.filter_apply_footer_hint' | translate }}</p>
            <span class="filters-card__footer-count" *ngIf="countActiveFilters()">
              {{ 'invoices_v2.list.filter_active_count' | translate: { count: countActiveFilters() } }}
            </span>
          </div>
          <div class="filters-card__footer-actions">
            <button type="button" class="btn-filter-secondary" (click)="resetFilters()">
              <i class="fa fa-undo" aria-hidden="true"></i>
              {{ 'invoices_v2.list.reset' | translate }}
            </button>
            <button type="button" class="btn-filter-link btn-filter-link--footer" (click)="closeFiltersSection()">
              {{ 'invoices_v2.list.filter_apply_close' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="list-selection-toolbar" *ngIf="hasListSelection">
      <span class="list-selection-toolbar__count">
        {{
          'invoices_v2.list.list_selected_count'
            | translate: { count: listSelectionCount }
        }}
      </span>
      <button type="button" class="btn-list-clear" (click)="clearListSelection()">
        {{ 'invoices_v2.list.list_selection_clear' | translate }}
      </button>
    </div>

    <!-- Table Section -->
    <div class="table-section">
      <div class="table-responsive-custom">
        <table class="data-table">
          <colgroup>
            <col class="col-bulk" />
            <col class="col-doc" />
            <col class="col-type" />
            <col class="col-date" />
            <col class="col-due" />
            <col class="col-payment" />
            <col class="col-company" />
            <col class="col-customer" />
            <col class="col-currency" />
            <col class="col-amount" />
            <col class="col-status" />
            <col class="col-procedure" />
            <col class="col-confirmation" />
            <col class="col-modified" />
            <col class="col-actions" />
          </colgroup>
          <thead>
            <tr>
              <th class="bulk-select-col">
                <input
                  *ngIf="invoicesData.length"
                  type="checkbox"
                  class="bulk-select-checkbox"
                  [checked]="isAllFilteredSelectedOrPageFullySelected()"
                  [indeterminate]="isListSelectAllIndeterminate()"
                  (change)="toggleSelectAllFiltered($event)"
                  [attr.aria-label]="'invoices_v2.list.list_select_all' | translate"
                />
              </th>
              <th>{{ 'invoices_v2.list.document_hash' | translate }}</th>
              <th>{{ 'invoices_v2.common.type' | translate }}</th>
              <th>{{ 'invoices_v2.common.document_date' | translate }}</th>
              <th>{{ 'invoices_v2.payment.due_date' | translate }}</th>
              <th>{{ 'invoices_v2.payment.payment_status' | translate }}</th>
              <th>{{ 'invoices_v2.common.company' | translate }}</th>
              <th>{{ 'invoices_v2.common.customer' | translate }}</th>
              <th>{{ 'invoices_v2.currency.document_currency' | translate }}</th>
              <th>{{ 'invoices_v2.common.amount' | translate }}</th>
              <th>{{ 'invoices_v2.common.status' | translate }}</th>
              <th>{{ 'invoices_v2.procedure.cycle_label' | translate }}</th>
              <th>{{ 'invoices_v2.list.confirmation_hash' | translate }}</th>
              <th>{{ 'invoices_v2.list.col_last_modified' | translate }}</th>
              <th>{{ 'invoices_v2.common.actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let item of invoicesData
                  | paginate: {
                      itemsPerPage: limit,
                      currentPage: currentPage,
                      totalItems: total
                    };
                let i = index
              "
              [class.row-selected]="highlightedInvoiceId === item.invoice_id || selectedInvoiceUuid === item.invoice_uuid"
              [class.row-highlight-pulse]="highlightedInvoiceId === item.invoice_id"
              [attr.data-invoice-row-id]="item.invoice_id"
              (click)="viewInvoice(item.invoice_id)"
              class="clickable-row"
            >
              <td class="bulk-select-cell" (click)="$event.stopPropagation()">
                <input
                  type="checkbox"
                  class="bulk-select-checkbox"
                  [checked]="isListRowSelected(item.invoice_id)"
                  (change)="toggleListInvoiceSelection(item.invoice_id, $event)"
                  [attr.aria-label]="'invoices_v2.list.list_select_row' | translate"
                />
              </td>
              <td
                class="doc-number-cell"
                [attr.data-label]="'invoices_v2.list.document_hash' | translate"
              >
                <span class="doc-number">{{ item.document_number || '-' }}</span>
              </td>
              <td [attr.data-label]="'invoices_v2.common.type' | translate">
                <span class="invoice-type-badge">{{ getInvoiceTypeLabel(item.invoice_type) }}</span>
              </td>
              <td class="date-cell" [attr.data-label]="'invoices_v2.common.document_date' | translate">
                <span class="date-value">{{ item.invoice_date | date: 'dd/MM/yyyy' : '' : 'en-GB' }}</span>
              </td>
              <td
                class="payment-inline-cell"
                [class.payment-inline-cell--editable]="canUpdatePaymentFromList(item)"
                [class.payment-inline-cell--active]="editingDueDateInvoiceId === item.invoice_id"
                [attr.data-label]="'invoices_v2.payment.due_date' | translate"
                (click)="$event.stopPropagation()"
              >
                <ng-container *ngIf="canUpdatePaymentFromList(item); else dueDateReadOnly">
                  <div
                    class="payment-inline-trigger"
                    [class.payment-inline-trigger--active]="editingDueDateInvoiceId === item.invoice_id"
                    (click)="startDueDateEdit(item, $event)"
                    [class.is-saving]="isSavingPaymentFor(item.invoice_id)"
                  >
                    <span class="date-value" [title]="!item.due_date ? ('invoices_v2.payment.add_due_date' | translate) : ''">{{
                      item.due_date
                        ? (item.due_date | date: 'dd/MM/yyyy' : '' : 'en-GB')
                        : ('invoices_v2.payment.add_due_date_short' | translate)
                    }}</span>
                    <i class="fa fa-pencil payment-inline-edit-icon" aria-hidden="true"></i>
                  </div>
                </ng-container>
                <ng-template #dueDateReadOnly>
                  <span class="date-value">{{
                    showPaymentTrackingInUi(item) && item.due_date
                      ? (item.due_date | date: 'dd/MM/yyyy' : '' : 'en-GB')
                      : '—'
                  }}</span>
                </ng-template>
              </td>
              <td
                class="payment-inline-cell"
                [class.payment-inline-cell--editable]="canUpdatePaymentFromList(item)"
                [attr.data-label]="'invoices_v2.payment.payment_status' | translate"
                (click)="$event.stopPropagation()"
              >
                <ng-container *ngIf="canUpdatePaymentFromList(item); else paymentStatusReadOnly">
                  <div class="payment-inline-wrap" (click)="$event.stopPropagation()">
                    <button
                      type="button"
                      class="payment-status-badge payment-status-badge--editable"
                      [class.payment-status-badge--menu-open]="openPaymentStatusMenuId === item.invoice_id"
                      [ngClass]="getPaymentStatusBadgeClass(item)"
                      [disabled]="isSavingPaymentFor(item.invoice_id)"
                      (click)="togglePaymentStatusMenu(item, $event)"
                    >
                      {{ getPaymentStatusLabel(item) || ('invoices_v2.payment.status_paid' | translate) }}
                      <i class="fa fa-caret-down" aria-hidden="true"></i>
                    </button>
                  </div>
                </ng-container>
                <ng-template #paymentStatusReadOnly>
                  <span
                    *ngIf="getPaymentStatusLabel(item) as payLabel"
                    class="payment-status-badge"
                    [ngClass]="getPaymentStatusBadgeClass(item)"
                  >
                    {{ payLabel }}
                  </span>
                  <span *ngIf="!getPaymentStatusLabel(item)">—</span>
                </ng-template>
              </td>
              <td [attr.data-label]="'invoices_v2.common.company' | translate">
                <span class="company-name" [title]="item.company | companyName:curentLang:item.company_name">
                  {{ ((item.company | companyName:curentLang:item.company_name) || '').substring(0, 20) }}{{ ((item.company | companyName:curentLang:item.company_name) || '').length > 20 ? '...' : '' }}
                </span>
              </td>
              <td [attr.data-label]="'invoices_v2.common.customer' | translate">
                <span class="customer-name" [title]="item.customer_name">
                  {{ item.customer_name?.substring(0, 20) || '-' }}{{ item.customer_name?.length > 20 ? '...' : '' }}
                </span>
              </td>
              <td [attr.data-label]="'invoices_v2.currency.document_currency' | translate">
                <span class="currency-code-badge" [class.currency-code-badge--foreign]="isForeignCurrencyInvoice(item)">
                  {{ getDocumentCurrencyDisplay(item) }}
                </span>
              </td>
              <td [attr.data-label]="'invoices_v2.common.amount' | translate" class="amount-cell">
                <span class="amount-value">{{ getDisplayAmount(item) | number: '1.2-2' }} ₪</span>
              </td>
              <td [attr.data-label]="'invoices_v2.common.status' | translate">
                <span
                  class="status-badge"
                  [ngClass]="{
                    'status-confirmed': item.confirm === 1 && item.is_deleted === 0,
                    'status-saved': item.confirm === 0 && item.is_deleted === 0,
                    'status-deleted': item.is_deleted === 1
                  }"
                >
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-check-circle': item.confirm === 1 && item.is_deleted === 0,
                      'fa-save': item.confirm === 0 && item.is_deleted === 0,
                      'fa-times-circle': item.is_deleted === 1
                    }"
                  ></i>
                  {{ getStatusLabel(item) }}
                </span>
              </td>
              <td [attr.data-label]="'invoices_v2.procedure.cycle_label' | translate" (click)="$event.stopPropagation()">
                <span *ngIf="itemIsInProcedureCycle(item)" class="procedure-cycle-cell">
                  <i
                    class="fa fa-gears procedure-gear"
                    [title]="'invoices_v2.procedure.open_actions' | translate"
                    (click)="openProcedureModal(item, $event)"
                  ></i>
                  <span *ngIf="item.procedure != null" class="procedure-cell-label">{{ getProcedureLabelForItem(item) }}</span>
                </span>
                <span *ngIf="!itemIsInProcedureCycle(item)">—</span>
              </td>
              <td [attr.data-label]="'invoices_v2.list.confirmation_hash' | translate">
                <span class="confirmation-number">{{ item.confirmation_number || '-' }}</span>
              </td>
              <td class="date-cell" [attr.data-label]="'invoices_v2.list.col_last_modified' | translate">
                <span class="date-value">{{ item.updatedDate ? (item.updatedDate | date: 'dd/MM/yyyy HH:mm' : '' : 'en-GB') : '—' }}</span>
              </td>
              <td class="actions-cell" (click)="$event.stopPropagation()">
                <div
                  class="actions-dropdown-wrapper"
                  ngbDropdown
                  container="body"
                  placement="bottom-end"
                  #dropdown="ngbDropdown"
                >
                  <button
                    type="button"
                    class="action-btn action-btn-dots"
                    ngbDropdownToggle
                    [id]="'dropdownActions-' + item.invoice_id"
                    [attr.aria-expanded]="dropdown.isOpen()"
                    [title]="'invoices_v2.common.actions' | translate"
                  >
                    <i class="fa fa-ellipsis-h"></i>
                  </button>
                  <div ngbDropdownMenu [aria-labelledby]="'dropdownActions-' + item.invoice_id" class="actions-dropdown-menu">
                    <button
                      ngbDropdownItem
                      class="dropdown-action-item view"
                      (click)="viewInvoice(item.invoice_id)"
                    >
                      <i class="fa fa-eye"></i>
                      <span>{{ 'invoices_v2.common.view' | translate }}</span>
                    </button>
                    <button
                      *ngIf="item.confirm === 0"
                      ngbDropdownItem
                      class="dropdown-action-item edit"
                      (click)="editInvoice(item.invoice_id)"
                    >
                      <i class="fa fa-edit"></i>
                      <span>{{ 'invoices_v2.common.edit' | translate }}</span>
                    </button>
                    <button
                      *ngIf="item.confirm === 0"
                      ngbDropdownItem
                      class="dropdown-action-item confirm"
                      (click)="confirmInvoice(item.invoice_id)"
                    >
                      <i class="fa fa-check"></i>
                      <span>{{ 'invoices_v2.common.confirm' | translate }}</span>
                    </button>
                    <button
                      *ngIf="item.confirm === 1"
                      ngbDropdownItem
                      class="dropdown-action-item pdf"
                      (click)="generatePdf(item.invoice_id, item.document_language)"
                    >
                      <i class="fa fa-file-pdf-o"></i>
                      <span>{{ 'invoices_v2.list.generate_pdf' | translate }}</span>
                    </button>
                    <button
                      *ngIf="itemIsInProcedureCycle(item)"
                      ngbDropdownItem
                      class="dropdown-action-item procedure"
                      (click)="openProcedureModal(item)"
                    >
                      <i class="fa fa-gears"></i>
                      <span>{{ 'invoices_v2.procedure.open_actions' | translate }}</span>
                    </button>
                    <button
                      *ngIf="canResendTaxAuthoritySecond(item)"
                      ngbDropdownItem
                      class="dropdown-action-item send-tax-second"
                      (click)="resendTaxAuthoritySecond(item.invoice_id)"
                    >
                      <i class="fa fa-paper-plane"></i>
                      <span>{{ 'invoices_v2.list.resend_tax_second' | translate }}</span>
                    </button>
                    <button
                      *ngIf="item.is_deleted === 0"
                      ngbDropdownItem
                      class="dropdown-action-item copy"
                      (click)="copyInvoice(item.invoice_id)"
                    >
                      <i class="fa fa-copy"></i>
                      <span>{{ 'invoices_v2.list.copy_invoice' | translate }}</span>
                    </button>
                    <button
                      *ngIf="item.confirm === 1 && item.is_deleted === 0 && canConvertInvoice(item.invoice_type)"
                      ngbDropdownItem
                      class="dropdown-action-item convert"
                      (click)="convertInvoice(item.invoice_id, item.invoice_type)"
                    >
                      <i class="fa fa-exchange"></i>
                      <span>{{ ('invoices_v2.list.convert_to' | translate) + getConvertToTypeName(item.invoice_type) }}</span>
                    </button>
                    <button
                      *ngIf="canCreateReverseInvoice(item)"
                      ngbDropdownItem
                      class="dropdown-action-item reverse"
                      (click)="createReverseInvoice(item.invoice_id)"
                    >
                      <i class="fa fa-undo"></i>
                      <span>{{ 'invoices_v2.list.create_reverse' | translate }}</span>
                    </button>
                    <button
                      *ngIf="item.confirm === 0"
                      ngbDropdownItem
                      class="dropdown-action-item delete"
                      (click)="deleteInvoice(item.invoice_id)"
                    >
                      <i class="fa fa-trash"></i>
                      <span>{{ 'invoices_v2.common.delete' | translate }}</span>
                    </button>
                  </div>
                </div>
              </td>
            </tr>

            <!-- Empty State -->
            <tr *ngIf="invoicesData.length === 0 && !isLoading">
              <td colspan="15">
                <div class="empty-state">
                  <i class="fa fa-inbox"></i>
                  <h5>{{ 'invoices_v2.list.no_invoices' | translate }}</h5>
                  <p>{{ 'invoices_v2.list.no_invoices_hint' | translate }}</p>
                </div>
              </td>
            </tr>

            <!-- Loading State -->
            <tr *ngIf="isLoading">
              <td colspan="15">
                <div class="loading-state">
                  <div class="spinner-custom"></div>
                  <p>{{ 'invoices_v2.list.loading_invoices' | translate }}</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Pagination Section -->
    <div class="pagination-section">
      <!-- Left: Items per page -->
      <div class="pagination-left">
        <span class="pagination-label">{{ 'invoices_v2.list.show' | translate }}</span>
        <select class="limit-select" [(ngModel)]="customLimit" (change)="onLimitChange()">
          <option [value]="10">10</option>
          <option [value]="25">25</option>
          <option [value]="50">50</option>
          <option [value]="100">100</option>
        </select>
        <span class="pagination-label">{{ 'invoices_v2.list.entries' | translate }}</span>
      </div>

      <!-- Center: Page info -->
      <div class="pagination-center">
        <div class="pagination-center__stack">
          <span class="page-info">
            {{ 'invoices_v2.list.showing_range' | translate: { start: offset + 1, end: offset + invoicesData.length, total: total } }}
          </span>
          <p
            class="subscription-quota-hint"
            *ngIf="hasSubscriptionPeriod() && subscriptionDocumentsUsed != null"
          >
            {{ 'invoices_v2.list.subscription_quota_hint' | translate: {
              used: subscriptionDocumentsUsed,
              start: formatSubscriptionPeriodDate(subscriptionPeriodStart),
              end: formatSubscriptionPeriodDate(subscriptionPeriodEnd)
            } }}
          </p>
        </div>
      </div>

      <!-- Right: Pagination controls -->
      <div class="pagination-right">
        <div class="custom-pagination">
          <!-- First Page -->
          <button 
            class="page-btn" 
            [disabled]="currentPage === 1"
            (click)="onPageChange(1)"
            [title]="'invoices_v2.list.first' | translate"
          >
            <i class="fa fa-angle-double-left"></i>
          </button>
          
          <!-- Previous Page -->
          <button 
            class="page-btn" 
            [disabled]="currentPage === 1"
            (click)="onPageChange(currentPage - 1)"
            [title]="'invoices_v2.list.previous' | translate"
          >
            <i class="fa fa-angle-left"></i>
          </button>

          <!-- Page Numbers -->
          <ng-container *ngFor="let page of getPageNumbers()">
            <button 
              *ngIf="page !== '...'"
              class="page-btn page-number" 
              [class.active]="page === currentPage"
              (click)="onPageChange(+page)"
            >
              {{ page }}
            </button>
            <span *ngIf="page === '...'" class="page-ellipsis">...</span>
          </ng-container>

          <!-- Next Page -->
          <button 
            class="page-btn" 
            [disabled]="currentPage === totalPages"
            (click)="onPageChange(currentPage + 1)"
            [title]="'invoices_v2.list.next' | translate"
          >
            <i class="fa fa-angle-right"></i>
          </button>

          <!-- Last Page -->
          <button 
            class="page-btn" 
            [disabled]="currentPage === totalPages"
            (click)="onPageChange(totalPages)"
            [title]="'invoices_v2.list.last' | translate"
          >
            <i class="fa fa-angle-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="openPaymentStatusMenuId != null && openPaymentStatusMenuItem"
  class="payment-status-popover"
  [ngStyle]="paymentStatusMenuStyle"
  role="menu"
  (click)="$event.stopPropagation()"
>
  <button
    type="button"
    class="payment-status-menu__item"
    role="menuitem"
    (click)="selectPaymentStatus(openPaymentStatusMenuItem, 'paid', $event)"
  >
    {{ 'invoices_v2.payment.status_paid' | translate }}
  </button>
  <button
    type="button"
    class="payment-status-menu__item"
    role="menuitem"
    (click)="selectPaymentStatus(openPaymentStatusMenuItem, 'unpaid', $event)"
  >
    {{ 'invoices_v2.payment.status_unpaid' | translate }}
  </button>
</div>

<div
  *ngIf="editingDueDateInvoiceId != null && editingDueDateItem"
  #dueDatePopover
  class="payment-due-popover"
  [ngStyle]="dueDatePopoverStyle"
  role="dialog"
  [attr.aria-label]="'invoices_v2.payment.due_date' | translate"
  (click)="$event.stopPropagation()"
>
  <div class="payment-due-popover__header">
    <span class="payment-due-popover__title">{{ 'invoices_v2.payment.due_date' | translate }}</span>
    <button type="button" class="payment-due-popover__close" (click)="cancelDueDateEdit($event)" aria-label="Close">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>
  <div class="payment-due-popover__body">
    <p-calendar
      class="p-calendar-custom payment-due-popover__calendar"
      [(ngModel)]="dueDateEditValue"
      [inline]="true"
      dateFormat="dd/mm/yy"
      [selectOtherMonths]="true"
      [showButtonBar]="true"
      [todayButtonStyleClass]="'p-button-text'"
      [clearButtonStyleClass]="'p-button-text'"
    ></p-calendar>
  </div>
  <div class="payment-due-popover__actions">
    <button
      type="button"
      class="payment-inline-btn payment-inline-btn--primary"
      (click)="saveDueDateInline(editingDueDateItem, $event)"
    >
      {{ 'invoices_v2.payment.save_payment' | translate }}
    </button>
    <button
      type="button"
      class="payment-inline-btn"
      (click)="clearDueDateInline(editingDueDateItem, $event)"
    >
      {{ 'invoices_v2.payment.clear_due_date' | translate }}
    </button>
    <button type="button" class="payment-inline-btn" (click)="cancelDueDateEdit($event)">
      {{ 'invoices_v2.common.cancel' | translate }}
    </button>
  </div>
</div>

<ng-template #exportDateModal let-modal>
  <div class="modal-header export-date-modal__header d-flex justify-content-between align-items-center">
    <h5 class="modal-title mb-0">{{ exportModalTitleKey() | translate }}</h5>
    <button type="button" class="close btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body export-date-modal">
    <p class="export-date-modal__hint">{{ 'invoices_v2.list.export_modal_hint' | translate }}</p>
    <div class="export-date-modal__row">
      <div class="export-date-modal__field">
        <label class="filter-label">{{ 'invoices_v2.list.from_date' | translate }}</label>
        <p-calendar
          class="p-calendar-custom"
          [(ngModel)]="exportModalFromDate"
          [showIcon]="true"
          appendTo="body"
          dateFormat="dd/mm/yy"
          [selectOtherMonths]="true"
          [placeholder]="'invoices_v2.list.date_placeholder' | translate"
          [maxDate]="exportModalToDate || maxFilterDate"
        ></p-calendar>
      </div>
      <div class="export-date-modal__field">
        <label class="filter-label">{{ 'invoices_v2.list.to_date' | translate }}</label>
        <p-calendar
          class="p-calendar-custom"
          [(ngModel)]="exportModalToDate"
          [showIcon]="true"
          appendTo="body"
          dateFormat="dd/mm/yy"
          [selectOtherMonths]="true"
          [placeholder]="'invoices_v2.list.date_placeholder' | translate"
          [minDate]="exportModalFromDate"
          [maxDate]="maxFilterDate"
        ></p-calendar>
      </div>
    </div>
    <p class="export-date-modal__note">{{ 'invoices_v2.list.export_modal_dates_note' | translate }}</p>
  </div>
  <div class="modal-footer export-date-modal__footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">
      {{ 'invoices_v2.common.cancel' | translate }}
    </button>
    <button
      type="button"
      class="btn"
      [ngClass]="exportModalFormat === 'excel' ? 'btn-export btn-export--excel' : 'btn-export btn-export--pdf'"
      (click)="confirmExportModal()"
      [disabled]="isExporting"
    >
      {{ 'invoices_v2.list.export_modal_confirm' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #procedureModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fa fa-gears"></i>
      {{ 'invoices_v2.procedure.cycle_title' | translate }}
    </h5>
    <button type="button" class="close btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <app-invoices-v2-procedure-panel
      *ngIf="procedureModalInvoice && procedureModalInvoiceId"
      [invoice]="procedureModalInvoice"
      [invoiceId]="procedureModalInvoiceId"
      [curentLang]="curentLang"
      (completed)="onProcedureActionCompleted()"
      (closed)="closeProcedureModal()"
    ></app-invoices-v2-procedure-panel>
  </div>
</ng-template>
